import React from "react";
import "../../css/CharacterTile.css";

export default function CharacterTile({
name = "Stembot",
imageSrc,
onBrush,
onClick,
onRemove,
canRemove = true,
selected = false,
bgSrc = "./assets/ui/pageCaret.png",
}) {
return (
<div className={`character-tile-main${selected ? " selected" : ""}`} onClick={onClick}>
{bgSrc ? <img className="tile-bg-img" src={bgSrc} alt="" aria-hidden="true" /> : null}
  <img className="char-tile-img" src={imageSrc} alt={name} />
  {onRemove && canRemove && (
    <button
      type="button"
      className="character-remove-btn"
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      title={`Delete ${name}`}
      aria-label={`Delete ${name}`}
    >
      x
    </button>
  )}
  <button
    type="button"
    className="char-tile-brush"
    onClick={(e) => {
      e.stopPropagation();
      onBrush?.();
    }}
    aria-label={`Paint ${name}`}
  >
    <img src="./assets/ui/paintbrush.png" alt="" />
  </button>
</div>
);
}
